import React from "react";
import { Box } from "@origin-digital/ods-core";
import { PremisesTable } from "src/components/Premises";

export const ContentSection = () => {
  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      data-id="contentSection.root"
    >
      <PremisesTable />
    </Box>
  );
};
